export function findDiscountInRoom(room, discountType) {
  return (room.discounts || []).find((discount) => discount.discount_type === discountType)
}
